// extracted by mini-css-extract-plugin
module.exports = {"wrap":"InfoList_wrap__2aZdn","title":"InfoList_title__2Kxsa","container":"InfoList_container__1-DMZ"};